import { ReactComponent as GitHub } from '../../images/icons/github.svg';
import { ReactComponent as AngelList } from '../../images/icons/angellist.svg';
import { ReactComponent as LinkedIn } from '../../images/icons/linkedin.svg';
import { ReactComponent as Twitter } from '../../images/icons/twitter.svg';

export const socialLinks = [
  { id: 0, icon: GitHub, link: 'https://github.com/Tobinchilongo' },
  { id: 1, icon: AngelList, link: 'https://angel.co/u/tobin-l-chilongo-jr' },
  { id: 2, icon: LinkedIn, link: 'https://www.linkedin.com/in/tobin-chilongo/' },
  { id: 3, icon: Twitter, link: 'https://twitter.com/Tobin_Official' },
];

export default 'SocialLinks';
